/*
  P Size Guide — tương tác cho snippets/p-size-guide.liquid

  Bảng đã render sẵn bằng Liquid; file này chỉ lo:
    1. Tính size từ chiều cao + cân nặng (tra thẳng ma trận đang hiển thị, không đoán)
    2. Highlight dòng + cột khi hover / focus
    3. Đổi tab
    4. Nút "Chọn size ..." — set option Size trên form rồi đóng drawer
    5. Sinh khối "Gợi ý phom theo số đo" (deterministic theo product.id)

  Dải số được đọc từ chính text của bảng: "1m70 – 1m74", "≤ 1m54", "< 1m90",
  "50 – 54 kg", "< 95 kg". Dải mở đầu/cuối được suy từ dải liền kề.
*/
(function () {
  'use strict';

  var STORE_KEY = 'p-sg:body';

  /* ---------- helpers ---------- */

  function nums(text) {
    var m = String(text).replace(/,/g, '.').match(/\d+(?:\.\d+)?/g);
    return m ? m.map(Number) : [];
  }

  // "1m70 – 1m74" -> 170,174 | "≤ 1m54" -> 154 | "70 – 74 kg" -> 70,74
  function toValues(text) {
    var t = String(text).trim();
    var isHeight = /m\s*\d|cm/i.test(t) || /^\s*[≤<>]?\s*1m/.test(t);
    var n = nums(t);
    if (!n.length) return null;
    if (isHeight) {
      // "1m70" bị tách thành [1, 70] -> ghép lại thành 170
      var joined = [];
      var raw = t.match(/1\s*m\s*(\d{1,2})/g);
      if (raw) {
        joined = raw.map(function (r) {
          return 100 + Number(r.replace(/[^\d]/g, '').slice(1));
        });
      }
      if (!joined.length) joined = n.filter(function (v) { return v > 100; });
      if (!joined.length) return null;
      return joined;
    }
    return n;
  }

  function parseRanges(labels) {
    var raw = labels.map(function (label) {
      var v = toValues(label) || [];
      var open = /^\s*[≤<]/.test(label);
      var openUp = /^\s*[>≥]/.test(label);
      if (!v.length) return null;
      if (v.length >= 2) return { min: v[0], max: v[1] };
      if (open) return { min: null, max: v[0] };
      if (openUp) return { min: v[0], max: null };
      return { min: v[0], max: v[0] };
    });

    // lấp dải mở bằng dải liền kề
    for (var i = 0; i < raw.length; i++) {
      var r = raw[i];
      if (!r) continue;
      if (r.min === null) {
        var prev = i > 0 ? raw[i - 1] : null;
        var nextR = raw[i + 1];
        if (prev && prev.max != null) r.min = prev.max + 1;
        else if (nextR && nextR.min != null && r.max != null) r.min = Math.max(0, r.max - (nextR.min - 1 - (r.max - 4)));
        else r.min = 0;
        if (r.min > r.max) r.min = Math.max(0, r.max - 4);
      }
      if (r.max === null) {
        var prev2 = i > 0 ? raw[i - 1] : null;
        r.max = prev2 && prev2.max != null ? prev2.max + 10 : r.min + 10;
      }
    }
    return raw;
  }

  function indexFor(ranges, value) {
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (r && value >= r.min && value <= r.max) return { index: i, exact: true };
    }
    // ngoài dải: lấy dải gần nhất
    var best = -1;
    var bestD = Infinity;
    for (var j = 0; j < ranges.length; j++) {
      var rr = ranges[j];
      if (!rr) continue;
      var d = value < rr.min ? rr.min - value : value - rr.max;
      if (d < bestD) { bestD = d; best = j; }
    }
    return best === -1 ? null : { index: best, exact: false };
  }

  function mulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ---------- widget ---------- */

  function initOne(root) {
    if (root.dataset.sgReady === '1') return;
    root.dataset.sgReady = '1';

    var table = root.querySelector('[data-sg-matrix]');
    if (!table) return;

    var colLabels = [].slice.call(table.querySelectorAll('thead th[data-col]')).map(function (th) {
      var el = th.querySelector('.p-sg__range');
      return (el ? el.textContent : th.textContent).trim();
    });
    var rowHeads = [].slice.call(table.querySelectorAll('tbody th[data-row]'));
    var rowLabels = rowHeads.map(function (th) { return th.textContent.trim(); });

    var colRanges = parseRanges(colLabels);   // cân nặng
    var rowRanges = parseRanges(rowLabels);   // chiều cao

    /* --- hover highlight dòng + cột ---
       Cột tô qua <col> và dòng tô qua <tr>: mỗi lần di chuột chỉ 2 thao tác DOM,
       và bỏ qua hoàn toàn khi vẫn đang ở trong cùng ô -> không giật. */
    var hlRow = null;
    var hlCol = null;
    var cols = {};
    [].slice.call(table.querySelectorAll('col[data-col]')).forEach(function (c) {
      cols[c.getAttribute('data-col')] = c;
    });

    function clearHl() {
      if (hlRow) { hlRow.classList.remove('is-hl-row'); hlRow = null; }
      if (hlCol) { hlCol.classList.remove('is-hl-col'); hlCol = null; }
    }

    function highlightFrom(cell) {
      if (!cell) { clearHl(); return; }

      var tr = cell.closest('tr');
      if (!tr || tr.parentElement.tagName !== 'TBODY') tr = null;
      var col = cols[cell.getAttribute('data-col')] || null;

      if (tr === hlRow && col === hlCol) return; // vẫn trong cùng ô -> không đụng DOM

      if (hlRow !== tr) {
        if (hlRow) hlRow.classList.remove('is-hl-row');
        if (tr) tr.classList.add('is-hl-row');
        hlRow = tr;
      }
      if (hlCol !== col) {
        if (hlCol) hlCol.classList.remove('is-hl-col');
        if (col) col.classList.add('is-hl-col');
        hlCol = col;
      }
    }

    table.addEventListener('mousemove', function (e) {
      var cell = e.target.closest('td, th');
      if (cell && table.contains(cell)) highlightFrom(cell);
    });
    table.addEventListener('mouseleave', clearHl);
    table.addEventListener('focusin', function (e) {
      var cell = e.target.closest('td, th');
      if (cell) highlightFrom(cell);
    });

    /* --- tabs --- */
    var tabs = [].slice.call(root.querySelectorAll('[data-sg-tab]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-sg-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        [].slice.call(root.querySelectorAll('[data-sg-panel]')).forEach(function (p) {
          p.hidden = p.getAttribute('data-sg-panel') !== name;
        });
      });
    });

    /* --- calculator --- */
    var inputH = root.querySelector('[data-sg-h]');
    var inputW = root.querySelector('[data-sg-w]');
    var btn = root.querySelector('[data-sg-go]');
    var resultBox = root.querySelector('[data-sg-result]');
    var resultText = root.querySelector('[data-sg-result-text]');
    var pickBtn = root.querySelector('[data-sg-pick]');

    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (saved && saved.h) inputH.value = saved.h;
      if (saved && saved.w) inputW.value = saved.w;
    } catch (err) { /* private mode: bỏ qua */ }

    function cellAt(rowIdx, colIdx) {
      var tr = table.querySelectorAll('tbody tr')[rowIdx];
      if (!tr) return null;
      return tr.querySelector('td[data-col="' + (colIdx + 1) + '"]');
    }

    function calc() {
      var h = Number(inputH.value);
      var w = Number(inputW.value);
      resultBox.hidden = false;
      resultBox.classList.remove('p-sg__result--warn');
      pickBtn.hidden = true;

      if (!h || !w) {
        resultText.textContent = 'Nhập cả chiều cao và cân nặng để xem size gợi ý.';
        resultBox.classList.add('p-sg__result--warn');
        return;
      }

      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({ h: h, w: w }));
      } catch (err) { /* bỏ qua */ }

      var r = indexFor(rowRanges, h);
      var c = indexFor(colRanges, w);
      [].slice.call(table.querySelectorAll('td.is-match')).forEach(function (td) {
        td.classList.remove('is-match');
      });

      if (!r || !c) {
        resultText.textContent = 'Số đo nằm ngoài bảng size hiện có. Liên hệ CSKH để được tư vấn.';
        resultBox.classList.add('p-sg__result--warn');
        return;
      }

      var cell = cellAt(r.index, c.index);
      var size = cell ? (cell.getAttribute('data-size') || '').trim() : '';

      if (!cell || !size || size === '—') {
        resultText.textContent = 'Với số đo này chưa có size phù hợp trong dải hiện có. Liên hệ CSKH để được tư vấn.';
        resultBox.classList.add('p-sg__result--warn');
        return;
      }

      cell.classList.add('is-match');
      highlightFrom(cell);
      try {
        cell.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      } catch (err) {
        cell.scrollIntoView();
      }

      var suffix = r.exact && c.exact ? '' : ' (số đo hơi lệch khỏi dải chuẩn, đây là size gần nhất)';
      resultText.innerHTML = 'Size phù hợp của bạn là <strong>' + size + '</strong>' + suffix;

      // size dạng "M (Nam)/ S (Nữ)" thì không tự chọn hộ
      if (size.indexOf('/') === -1 && findOptionInput(size)) {
        pickBtn.hidden = false;
        pickBtn.textContent = 'Chọn size ' + size;
        pickBtn.dataset.size = size;
      }
    }

    btn.addEventListener('click', calc);
    [inputH, inputW].forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); calc(); }
      });
    });

    /* --- chọn size trên form --- */
    // variant-radios của theme KHÔNG nằm trong form[action="/cart/add"] -> quét cả 2 nơi
    function optionScopes() {
      var list = [].slice.call(
        document.querySelectorAll('variant-radios, variant-selects, variant-mixed-inputs')
      );
      return list.concat([].slice.call(document.querySelectorAll('form[action*="/cart/add"]')));
    }

    function findOptionInput(size) {
      var wanted = size.trim().toLowerCase();
      var scopes = optionScopes();

      for (var i = 0; i < scopes.length; i++) {
        var radios = scopes[i].querySelectorAll('input[type="radio"]');
        for (var j = 0; j < radios.length; j++) {
          if ((radios[j].value || '').trim().toLowerCase() === wanted) return radios[j];
        }
        var selects = scopes[i].querySelectorAll('select');
        for (var k = 0; k < selects.length; k++) {
          var opts = selects[k].options;
          for (var n = 0; n < opts.length; n++) {
            if ((opts[n].value || '').trim().toLowerCase() === wanted) return selects[k];
          }
        }
      }
      return null;
    }

    pickBtn.addEventListener('click', function () {
      var size = pickBtn.dataset.size;
      var el = findOptionInput(size);
      if (!el) return;

      if (el.tagName === 'SELECT') {
        el.value = size;
      } else {
        el.checked = true;
        el.click();
      }
      el.dispatchEvent(new Event('change', { bubbles: true }));

      // đóng drawer bằng chính nút close của theme (giữ nguyên a11y-dialog)
      var popup = root.closest('.popup');
      var close = popup && popup.querySelector('[data-a11y-dialog-hide]');
      if (close) close.click();
    });

    /* --- gợi ý phom theo số đo --- */
    if (root.getAttribute('data-tryon') === '1') buildTryOn(root, table, rowRanges, colRanges);
  }

  /* ---------- try-on ---------- */

  // nhóm avatar theo vóc dáng (xem issues/PLAN-003 mục 3)
  var AVATAR_GROUPS = {
    lean: [1, 2, 9, 15, 19],
    mid: [3, 4, 7, 10, 11, 13, 17, 18],
    heavy: [5, 8, 12, 14, 16],
    broad: [6, 20]
  };

  function groupFor(weight) {
    if (weight < 60) return 'lean';
    if (weight < 73) return 'mid';
    if (weight < 83) return 'heavy';
    return 'broad';
  }

  function feelFor(weight, range) {
    var span = Math.max(1, range.max - range.min);
    var pos = (weight - range.min) / span;
    if (pos >= 0.66) return 'Ôm nhẹ';
    if (pos <= 0.33) return 'Rộng thoải mái';
    return 'Vừa vặn';
  }

  function buildTryOn(root, table, rowRanges, colRanges) {
    var box = root.querySelector('[data-sg-tryon]');
    var body = root.querySelector('[data-sg-tryon-body]');
    if (!box || !body) return;

    var avatars = (box.getAttribute('data-avatars') || '').split(',').filter(Boolean);
    var names = (box.getAttribute('data-names') || '').split(',').map(function (n) { return n.trim(); });
    if (!avatars.length) return;

    var seed = Number(root.getAttribute('data-seed')) || 1;
    var rand = mulberry32(seed);

    // gom các ô hợp lệ theo size
    var bySize = {};
    var rows = table.querySelectorAll('tbody tr');
    for (var i = 0; i < rows.length; i++) {
      var tds = rows[i].querySelectorAll('td[data-col]');
      for (var j = 0; j < tds.length; j++) {
        var size = (tds[j].getAttribute('data-size') || '').trim();
        if (!size || size === '—' || size.indexOf('/') > -1) continue;
        if (!rowRanges[i] || !colRanges[j]) continue;
        (bySize[size] = bySize[size] || []).push({ h: rowRanges[i], w: colRanges[j] });
      }
    }

    var sizes = Object.keys(bySize);
    if (!sizes.length) return;
    if (sizes.length > 5) {
      // rải đều thay vì cắt cụt: lấy 5 size cách quãng
      var step = sizes.length / 5;
      var picked = [];
      for (var s = 0; s < 5; s++) picked.push(sizes[Math.floor(s * step)]);
      sizes = picked;
    }

    var used = {};
    var html = sizes.map(function (size) {
      var cells = bySize[size];
      // ưu tiên ô có chiều cao phổ biến (1m60–1m80) để tránh cặp số đo cực đoan kiểu 1m59 / 71kg
      var common = cells.filter(function (c) { return c.h.min >= 158 && c.h.max <= 182; });
      if (common.length) cells = common;
      var cell = cells[Math.floor(rand() * cells.length)];
      var h = cell.h.min + Math.floor(rand() * (cell.h.max - cell.h.min + 1));
      var w = cell.w.min + Math.floor(rand() * (cell.w.max - cell.w.min + 1));

      var group = AVATAR_GROUPS[groupFor(w)];
      var idx = group[Math.floor(rand() * group.length)];
      var guard = 0;
      while (used[idx] && guard < 20) {
        idx = group[Math.floor(rand() * group.length)];
        guard++;
      }
      used[idx] = true;

      var src = avatars[idx - 1] || avatars[0];
      var name = names[idx - 1] || '';
      var heightText = '1m' + String(h - 100).padStart(2, '0');

      return (
        '<tr>' +
        '<td class="p-tryon__td-person"><span class="p-tryon__person">' +
        '<img class="p-tryon__avatar" src="' + src + '" alt="" loading="lazy" width="32" height="32">' +
        '<span class="p-tryon__name">' + name + '</span></span></td>' +
        '<td><strong>' + size + '</strong></td>' +
        '<td>' + heightText + '</td>' +
        '<td>' + w + ' kg</td>' +
        '<td>' + feelFor(w, cell.w) + '</td>' +
        '</tr>'
      );
    });

    body.innerHTML = html.join('');
  }

  /* ---------- boot ---------- */

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-p-sg]')).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // popup của theme được chuyển vào #modals sau khi load -> init lại khi mở
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-a11y-dialog-show]')) setTimeout(initAll, 80);
  });
})();
